import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

import { useQueryString } from './useQueryString';

function useQueryStringState<T extends string = string>(
  key: string,
  initialValue: T
): [T, (value: T) => void] {
  const navigate = useNavigate();
  const queryStrings = useQueryString();

  const [value, setValue] = useState<T>(() => {
    const query = queryStrings.get(key) as T;
    return query ? query : initialValue;
  });
  const onSetValue: (newValue: T) => void = useCallback(
    (newValue: T) => {
      setValue(newValue);
      queryStrings.set(key, newValue);

      navigate({ search: `?${queryStrings.toString()}` });
    },
    [key, navigate, queryStrings]
  );

  return [value, onSetValue];
}

export default useQueryStringState;
